// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2moGf","productName":"Table_productName__28iKy"};